<div [id]="'textarea-' + id" (mousemove)="tooltipFollowCursor($event)" class="textarea relative">
  <svg-icon *ngIf="value === '' && disabled && isTeacher; else student" [key]="categoryid !== category.EJERCICIOS?'presentation':'icon-edit'" class="aria-hidden mr-2 textarea__icon" size="lg" [color]="'#BDBDBD'"></svg-icon>
  <ng-template #student>
    <svg-icon *ngIf="value === ''" [key]="categoryid !== category.EJERCICIOS?'icon-notebook':'icon-edit'" class="aria-hidden mr-2 textarea__icon" size="md"></svg-icon>
  </ng-template>
  <textarea class="tooltip" name="{{ controlName }}" [(ngModel)]="value" [disabled]="disabled"></textarea>
  <tekman-tooltip *ngIf="disabled" [id]="'tooltip-' + id" [text]="tooltipText | translate"></tekman-tooltip>
</div>

